let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iVXva")).then(() => parcelRequire('b9HNL'));